 <template>
    <div style="background:white; height:100%;display:flex">
        <div style="min-width:160px;max-width:160px;border-right:3px solid #ccc;overflow:auto ">
            <div  class="oneMenu" style="margin-top:2px">
                <div  :class="{active: actitem==='box'}" @click="itemClick('box')">
                    <i class="iconfont icon-duanxin1" style="font-size:20px;margin-right:5px;color:#ccc;margin-left:2px"></i>
                    {{boxnum}}
                </div> 
            </div>
            <div  class="oneMenu">
                <div  :class="{active: actitem==='draft'}" @click="itemClick('draft')">
                    <i class="iconfont icon-caogaoxiang" style="font-size:18px;margin-right:5px;color:#ccc;margin-left:2px"></i>
                    {{draftnum}}
                </div> 
            </div>
            <div  class="oneMenu">
                <div  :class="{active: actitem==='sent'}" @click="itemClick('sent')">
                    <i class="iconfont icon-fujian" style="font-size:18px;margin-right:5px;color:#ccc;margin-left:2px"></i>
                    已发送
                </div> 
            </div>
            <!-- <div  class="oneMenu">
                <div  :class="{active: actitem==='attach'}" @click="itemClick('attach')">
                    <i class="iconfont icon-faqi" style="font-size:18px;margin-right:5px;color:#ccc;margin-left:2px"></i>
                    邮箱附件
                </div> 
            </div> -->
            <div v-for="(item,index) in menuArr " :key="index">
                <div  class="oneMenu">
                    <div  :class="{active: actitem===item.IDSEQ}" @click="itemClick(item.IDSEQ)">
                        <i class="iconfont icon-fenzu" style="font-size:18px;margin-right:5px;color:#ccc;margin-left:2px"></i>
                        {{item.FOLDNM}} <i @click="delFold(item.IDSEQ)" class="iconfont icon-shanchu1" style="margin-left:10px"></i>
                    </div> 
                </div>
            </div>
  
        </div>
        <div :style="{'min-width':divWidth}"> 
            <div style=" background:white;line-height:30px; border-bottom:2px solid #389;height:38px"> 
                <div style="padding-top:3px;display:flex;width:1400px;line-height:30px ">
                    <div style="margin-top:2px;margin-right:15px;margin-left:3px" class="divButton" @click="receiveMail" >
                        <i class="iconfont icon-xiazai" style="color:#fFF;font-size:14px;margin-right:5px;margin-left:4px;line-height:20px"></i>
                        <el-link :disabled="addBool"  :underline="false"  ><span style="font-size:12px;color:#fff ">收邮件 </span></el-link>
                    </div>
                    <el-dropdown size="mini" @command ="downClick">
                        <el-button type="primary" size="mini">
                            移动到<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <div v-for="(item,index) in menuArr " :key="index"  >
                                <el-dropdown-item  style="line-height:33px;height:33px"><i class="iconfont icon-fenzu"></i>{{item.FOLDNM}}</el-dropdown-item>
                            </div>
                            <el-dropdown-item command="move" style="line-height:33px;height:33px"><i class="iconfont icon-fenzu"></i>新建文件夹并移动</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> 
                </div>
            </div>  
            <el-table  :data="tabData" 
                border                            
                size="small"
                class="custom-table-border"
                header-cell-class-name="clearPadding"
                :header-cell-style="{ 'color':'#389','text-align':'center'}"
                v-loading="v_loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                :height="subHeight" 
                :row-key="getRowKey"
                :cell-style="{padding:'2px'}"
                ref="reftab"
                highlight-current-row
                @selection-change="handleSelectionChange"
                style="overflow:auto;margin-top:1px;"> 
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column label="序号" type="index" width="60" fixed>
                    <el-table-column label="序号" type="index" width="60" fixed>
                        <template slot="header"  >
                            <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                                <el-tooltip content=" 清除条件" effect="light">
                                    <i class="iconfont icon-shanchu1"  ></i>
                                </el-tooltip>
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column  v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                    :min-width="item.width">
                    <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align" show-overflow-tooltip :min-width="item.width">
                        <template slot="header" slot-scope="scope">
                            {{scope.row}}
                            <el-select v-if="item.key=='STFG'" @change="inputQry" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                                <el-option label="未读" value="N"></el-option>
                                <el-option label="已读" value="Y"></el-option>
                            </el-select>
                            <el-select v-else-if="item.edcss=='checkbox'" @change="inputQry" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                                <el-option label="是" value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                            <el-date-picker v-else-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                            <el-input type="number" placeholder="数字框"  @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                            <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                        </template>
                        <template slot-scope="scope">
                            <el-link v-if="item.key=='IDNO2'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:11px ">{{scope.row[item.key]}}</div> </el-link>
                            <el-checkbox disabled v-else-if="item.edcss=='checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">已读</el-tag>
                            <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']!=='Y'" size="mini" type="info" effect="dark">未读</el-tag>   
                            <span v-else-if="item.key=='ISATTACH'&&scope.row['ISATTACH']=='Y'"><i class="iconfont icon-fujian" style="font-size:18px"></i></span>
                            <span v-else-if="item.key=='ISATTACH'&&scope.row['ISATTACH']!=='Y'"> </span>
                            <span v-else  >{{scope.row[item.key]}}</span>
                        </template>
                    </el-table-column> 
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="80">
                    <template slot-scope="scope">
                        <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link  @click="editRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px">查看</span></el-link> 
                        <!-- <span v-if="scope.row['STFG']=='N'" > 
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                            <el-link  @click="editRec(scope.row,'N',scope.$index)" :underline="false" style=" margin-right:5px; "><span style="font-size:12px;margin-right:5px">编辑</span></el-link> 
                        </span>
                        <span v-if="scope.row['STFG']=='N'" > 
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                            <el-link  @click="delRec(scope.row, scope.$index )" :underline="false" ><span style="font-size:12px;">删除</span></el-link> 
                        </span> -->
                    </template>
                </el-table-column>  
            </el-table>
            <!-- 分页查询 -->
            <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
                <div style="float: left;padding-left:4px;font-size:12px;">
                    <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                </div>
                <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                    <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                    <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                        <el-option 
                            v-for="item in pageList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                    <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                    <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                    <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
                </div>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-div">
                        <span class="oneRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="120"   label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="item.title"  :class=" item.FLDNO=='TITLE'?'item-one':item.EDCSS=='button'?'item-width2': 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <el-date-picker size="medium" :disabled="saveFlag||item.DISABLED=='Y'" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-checkbox size="medium" :disabled="saveFlag" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select size="medium" filterable :disabled="item.DISABLED==='Y'?true:false||saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                </el-select>
                                <el-input  size="medium" :disabled="saveFlag" readonly  v-else-if="item.EDCSS=='button'" placeholder="请选择" v-model="mainRow[item.FLDNO]" style="width:100%; padding-left:30px"> 
                                    <template slot="prefix" > <el-link @click="inputClear( item.key)" :underline="false" style="margin-top:3px" ><i class="iconfont icon-shanchu1" ></i></el-link></template>
                                    <template slot="suffix" > <el-link @click="inputBtn( item.key)" :underline="false" style="margin-top:3px" ><i class="iconfont icon-icon-choose" ></i></el-link></template>
                                </el-input>      
                                <el-input clearable :disabled="saveFlag" v-else-if="item.EDCSS==='textarea'" type="textarea" :rows="2"  placeholder="请输入内容" v-model="mainRow[item.FLDNO]" maxlength="1000" show-word-limit ></el-input>
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag " clearable v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>  
                <div class="one-div">
                    <span class="oneRow"> 邮件内容</span>
                </div> 
                <div style="margin-top:3px;width:100%;padding-right:10px;" >
                    <tinymce   id="refnew" v-model="newHtml" height="260" v-if="addWin" ></tinymce>
                </div>              
                <div class="one-div">
                    <span class="oneRow"> 上传附件</span>
                </div>
                <div style="display:flex" >
                    <Upload
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :with-credentials="true"                            
                        :format="['jpg','jpeg','png','pdf' ]"
                        :max-size="5120"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :disabled="saveFlag"
                        :on-progress="handleProgress"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex; "  >
                        <span v-for="(item,index) in imgData" :key="index">  
                            <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;margin-right:30px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH"></el-image>
                            <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item.IDSEQ,item.LSTSEQ,item.FILEPATH,index)"><Icon type="md-close" /> 删除</el-link>
                                <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> 预览</el-link>
                            </div>
                        </span>
                    </div> 
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <!-- <i v-if="mainRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                    <i v-else-if="mainRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i> -->
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu" style="margin-left:30px;">  取消</el-button>
                    <el-button @click="saveRec('N')" :disabled="addBool||saveFlag" size="small" type="danger" style="margin-left:50px;" icon="iconfont icon-baocun"  > 保存为草稿 </el-button > 
                    <el-button @click="saveRec('Y')" :disabled="addBool||saveFlag" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-faqi"  > 直接发送 </el-button > 
                </span>
            </div>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_random="v_random" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>  
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="foldWin" width="450px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">创建文件夹</span>
            </div> 
 
            <div style="line-height:40px;height:50px;display:flex"> 
                <div style="width:120px;color:red">*文件夹名称：</div> 
                <el-input  type="text" size="mmedium"   v-model="v_foldrow['FOLDNM']"></el-input>
            </div>
            <div style="line-height:40px;height:50px;display:flex"> 
                <div style="width:120px">指定联系人：</div> 
                <el-input  type="text" size="mmedium"  readonly v-model="v_foldrow['MAILADDR']">
                    <template slot="suffix" > <el-link @click="inputBtn('POINT')" :underline="false" style="margin-top:3px" ><i class="iconfont icon-icon-choose" ></i></el-link></template>
                </el-input>
            </div>
  
            <div style="line-height:30px;height:65px;display:flex;font-size:13px;font-weight:600;color:red">
                提示： 收取指定联系人邮件到该文件夹。 
            </div>
            <span slot="footer"  >
                <el-button type="info" @click="foldWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                <el-button @click="foldSave" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-yiqueren-xianxing"  > 确定 </el-button> 
            </span>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubmulti.vue' 
import repWin from '../datamgt/repWin.vue' 
import tinymce from '@/components/Tinymce' 
export default {
    name:'mail_receive',
    data () {
        return {
            loadWin:false ,
            foldWin:false,
            v_foldrow:{},
            repWin:false,
            repUrl:'',
            mainRow:{},
            newHtml:'',
            promptWin:false,
            v_random:'',
            userData:[],
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            selparam:'IDSEQ',
            txtparam:'',
            selparam2:'',
            txtparam2:'',
            oper2:'like',
            mailCol:[],
            comboArr:[],
            goPage:'',
            boxnum:'',
            draftnum:'草稿箱',
            tabData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            chkBool:false, //确认权限
            v_loading:false,
            current:1,
            saveFlag:false,
            actitem:'box',
            allList:[], //询价单集合
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            dataCount:0,
            rowSize:50,
            tabCol:[],
            operArr:[],
            oper:'like',
            menuArr:[],
            v_rowIndex:'',
            notNull:[],
            stfgBool:true,
            v_formurl:'xuper_auth/getFormGroup', 
            formArr:[],
            v_admin:this.$cookies.get('v_admin') , 
            v_table:'',
            tableCol :[],
            v_key:'',
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_commit :true,
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            fileName:'',
            uploadUrl:'/xuper_oss/uploadImg' ,
            Accept: "png,jpg,jpeg,gif,tiff,pdf",
            delImg:[],
            v_row:{},
        }
    },
    components: {
        repWin,
        pubWin,
        tinymce,
    },
    computed: {
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
        subHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 296) + 'px';
        }, 
        divWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    watch: {
 
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'telno',this.v_username,'','','V_MAIL_PWD','').then(res=>{
            this.userData =res.result
        })
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        this.comSelect()
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','427739','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ // 确认
                    this.chkBool=true
                }
            }
        })    
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','427739','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','427739','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
 
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','427739','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        this.getMenuList()
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getTabList('') // 查询记录   
            console.log(window.location.origin)
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        // 接收邮件
        receiveMail(){
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'V_hr_emp',corpid:this.v_corpid,p_key2:'telno',p_value2:this.v_username,p_user:this.v_username},
            }).then(res =>{
                let v_result = res.result[0]
                if (!v_result['MAILADDR']){
                    this.promptWin =true
                    this.prompt ='你的账号还没有设置阿里邮箱'
                }else if (!v_result['MAILPWD']){
                    this.promptWin =true
                    this.prompt ='你的账号还没有设置阿里邮箱的授权码'
                }else {
                    this.loadWin =true
                    //p_key: 地址，p_value: 授权码 ，corpid ,p_table,p_user
                    this.$axios({
                        method: 'post',
                        url:'/xuper_oss/receiveAliMail',
                        data: {p_key:v_result['MAILADDR'],p_value:v_result['MAILPWD'],corpid:this.v_corpid,p_user:this.v_username,p_table:'MAIL_RECEIVE' },
                    }).then(res=>{
                        if (res.code!=='200'){
                            this.promptWin =true
                            this.prompt =res.result 
                            this.loadWin =false
                        }else{
                            this.loadWin =false
                        }
                    })
                }
            })
        },
        //删除记录
        delFold(idseq){
            this.$confirm('你确定要删除此文件夹吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:idseq,  p_table:'MAIL_FOLD' },
                }).then(res=>{
                    this.getMenuList()
                    this.itemClick('box')
                })
            }).catch(err =>{})
        } ,
        downClick(val){
            if (val =='move'){
                this.v_foldrow ={}
                this.foldWin =true
            }
        },
        //指定文件夹保存
        foldSave(){
            let v_bool =false
            if (!this.v_foldrow['FOLDNM']){
                this.promptWin =true
                this.prompt ='文件夹不能为空'
            }else{
                this.menuArr.some(item=>{
                    if (item['FOLDNM'].toLowerCase()==this.v_foldrow['FOLDNM'].toLowerCase()){
                        v_bool =true
                    }
                })
                if (v_bool ){
                    this.promptWin =true
                    this.prompt ='文件夹有同名，请核查'
                }else{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.v_foldrow,{CORPID:this.v_corpid,oper:this.v_username })), p_table:'MAIL_FOLD',frmid:''},
                    }).then(res=>{ 
                        let v_idseq =res.idseq
                        this.getMenuList()
                        this.foldWin =false
                    })
                }
            }
        },
        handleSelectionChange(val) {
            this.multiSelection = val
        },
        itemClick(val){
            this.tabData =[]
            this.actitem =val
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'V_mail_receive_qry',p_key:'corpid',p_value:this.v_corpid,p_key2:'gpnm',p_value2:val,p_key3:'adduser',p_value3:this.v_usernm},
            }).then(res =>{
                this.tabData =res.result
                if (val=='box'){
                    this.boxnum ='收件箱 ( '+ this.tabData.length+' )'
                }else if (val=='draft'){
                    this.draftnum ='草稿箱 ( '+ this.tabData.length+' )'
                }
            }) 
        },
        // 确认选择
        btnSure(obj){
            let v_val =''
            obj.forEach(item =>{
                if (v_val){
                    v_val =v_val+',' +item['ADDR']
                }else{
                    v_val =item['ADDR']
                }
            })
            if (this.v_key =='MAILTO') {
                Object.assign(this.mainRow, { MAILTO:v_val } )
            }else if (this.v_key =='MAILCC') {
                Object.assign(this.mainRow, { MAILCC:v_val } )
            }else if (this.v_key =='POINT') {
                Object.assign(this.v_foldrow , { MAILADDR:v_val } )
            }
            this.btnWin =false
        }, 
        inputClear(key){
            if (key =='MAILTO') {
                this.mainRow['MAILTO']=''
                this.$forceUpdate()
            }else if (key =='MAILCC') {
                this.mainRow['MAILCC']=''
                this.$forceUpdate()
            }
        },
        inputBtn( key){   
            this.v_key =key   
            this.v_random='r'+Math.random() 
            this.v_table ='v_bs_mail'
            this.tableCol =this.mailCol
            this.v_key2 ='stfg'
            this.v_value2 = 'Y'
            this.btnWin =true
        },
        //删除记录
        delRec(row,index){
            this.$confirm('你确定要删除此记录吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'],  p_table:'MAIL_RECEIVE' },
                }).then(res=>{
                    this.tabData.splice(index,1)
                })
            }).catch(err =>{})
        } ,
        //字段查询
        inputQry(){
            this.stfgChange()
        },
 
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.stfgChange()
        } ,
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(idseq,lstseq,path,index){
            this.$confirm('你确定要删除此附件吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:idseq,LSTSEQ:lstseq,FILEPATH:path}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择pdf或图片格式'
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出5M' 
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            let v_filename='/assets/email/'+this.fileName+file.name.substring(file.name.lastIndexOf('.'))
            this.imgData.push({FILEPATH:v_filename})                   
        },
        //上传文件之前的钩子  
        beforeImgFile (res, file) {        
            this.fileName= this.v_username+getDate('year')+'-RD'     
            this.uploadData = {
                code: this.fileName ,
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 

        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        getMenuList(){ 
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'V_MAIL_FOLD',p_key:'corpid',p_value:this.v_corpid,p_key2:'oper',p_value2:this.v_username},
            }).then(res =>{
                this.menuArr =res.result
            })  
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'427739',p_cond:' and lstseq in (1 )' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //查询附件数据
        qryImgData(idseq){
            this.imgData=[]
            getTabColOrData(this.v_url,'v_MAIL_RECEIVE_dtl','idseq',idseq,'','').then((res) => {              
                if (res){
                    this.imgData =res.result
                }
            })
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                 this.saveFlag=false 
            }
            this.mainRow =JSON.parse(JSON.stringify( row ))
            this.qryImgData(row.IDSEQ)
            this.addWin=true  
            this.v_commit =true
   
            this.$nextTick(()=>{
                this.setLobData(row['IDSEQ'])               
            })
            //更新阅读标识
            if (row['STFG']!=='Y') {
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'MAIL_RECEIVE' ,p_cond:' set stfg=\'Y\'' },
                }).then(res=>{
                    Object.assign(row,{STFG:'Y'})
                })
            }
        },
        setLobData(idseq ){
            let vm =this
            this.$axios({
                method: 'post',
                url:'xuper_auth/getClobData',
                data: {p_key:'idseq',p_value:idseq,  p_table:'v_MAIL_RECEIVE' },
            }).then(res=>{ 
                if (res.code=='200'){
                    this.$nextTick(()=>{
                        setTimeout(() => {
                            window.tinymce.get('refnew').setContent(res.result[0].note)    
                        }, 500)                 
                    })   
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
        },
        //保存记录
        saveRec(v_action){
            //富文本框的回显与编辑问题，如果在 el-dialog里，就需在关闭对话框时 一起销毁，在富文本上加上 v-if =dialog 的 visible.sync
            //让富文本与 对话框 一同渲染
            let v_flag =true
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            if (v_action =='Y'){  //直接发送邮件
                if (!this.mainRow['MAILADDR'] ){
                    v_flag =false
                    this.promptWin=true
                    this.prompt='发送邮箱不能为空'
                }else if (!this.mainRow['MAILPWD'] ){
                    v_flag =false
                    this.promptWin=true
                    this.prompt='发送邮箱密钥不能为空'
                }
            }
            //发起保存请求   
            if (this.stfgBool &&this.v_commit && v_flag) {   
                this.v_commit =false
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.mainRow,{CORPID:this.v_corpid,STFG:v_action,'OPERUSER':this.v_username})), p_table:'MAIL_RECEIVE',frmid:'427739'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_ =res.idseq
                        //1、图片保存
                        for(var k=0;k<this.imgData.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                            })
                        }  
                        //2、图片删除处理
                        for(let k=0;k<this.delImg.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                            })    
                        } 
                        //更新大对象
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_cond:' set note=\''+this.newHtml+'\'',p_table:'MAIL_RECEIVE',p_key:'idseq',p_value:idseq_ },
                        }).then(res=>{
                            if (res.code=='200'){
                                if (v_action =='Y'){ //发送邮件
 
                                    this.$axios({
                                        method: 'post',
                                        url:'/xuper_oss/sendAliMail',
                                        data: {p_value5:idseq_,p_key:this.mainRow['MAILADDR'],p_value:this.mainRow['MAILPWD'],p_key2:this.mainRow['ADDUSER'],p_value2:this.mainRow['MAILTO'],p_key3:this.mainRow['TITLE'],p_value3:this.mainRow['MAILCC'] },
                                    }).then(res=>{
                                        if (res.code!=='200'){
                                            this.promptWin =true
                                            this.prompt =res.result 
                                        }
                                    })
                                }
                            }else{
                                this.promptWin =true
                                this.prompt =res.result
                            }
                        }) 
                        this.addWin =false   
                        this.stfgChange()
                      
                    }else{  
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
        },

        //新增
        addRec(){
            this.addWin=true
            this.saveFlag=false 
            this.mainRow={}
            this.mainRow={ 'IDSEQ':'','STFG':'N',ADDUSER:this.v_usernm }
            this.imgData=[]
            this.v_commit =true 
            if (this.userData.length>0){
                this.mainRow['MAILADDR'] =this.userData[0]['MAILADDR']
                this.mainRow['MAILPWD'] =this.userData[0]['PWD']
            }
            this.$nextTick(()=>{
                setTimeout(() => {
                    window.tinymce.get('refnew').setContent('')    
                }, 500)                 
            })  
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
  
 
        //状态查询
        stfgChange(){
            let cond_='' ,v_edcss=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and upper('+this.selparam+') like upper(\'%' + this.txtparam+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam+')' +this.oper+'upper(\''+this.txtparam+'\')'
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and upper('+this.selparam2+') like upper(\'%' + this.txtparam2+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam2+')' +this.oper2+'upper(\''+this.txtparam2+'\')'
                }
            }
            let v_cond =''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            this.getTabList(cond_+v_cond)
        }, 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.tabData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            
        },
 
        //查询清单 
        getTabList(cond){
            let vm =this ,v_cond=''
            this.v_loading=true
            v_cond =' order by '+this.selparam+' desc' 
            // if (this.v_admin =='N' ){
            //    v_cond= ' and OPERUSER=\''+this.v_username+'\' order by '+this.selparam+' desc' 
            // }else{
            //     v_cond =' order by '+this.selparam+' desc' 
            // }
            getTabColOrData(this.v_url,'V_MAIL_RECEIVE_QRY','gpnm',this.actitem,'CORPID',this.v_corpid,'','',cond+ v_cond).then((res) => { 
                this.allList =res.result 
                if (this.actitem =='box'){
                    this.boxnum ='收件箱 ( '+ this.allList.length+' )'
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs['reftab'].doLayout()
                    this.v_loading=false
                }) 
                this.initPage() 
            })
            getTabColOrData(this.v_url,'V_MAIL_RECEIVE_QRY','gpnm','draft','CORPID',this.v_corpid,'','','').then((res) => { 
                this.allList =res.result 
                this.draftnum ='草稿箱 ( '+ this.allList.length+' )'
            })
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','427739','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','427904','lstseq','2','','','   order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.mailCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        holder:res.result[k].HOLDER,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .active { 
        color:#FFF; 
        background: #389;
        border-left:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        margin-top:2px;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .divButton{
        display:flex;
        border:1px solid #ccc;
        background:green;
        color:#fff;
        padding:3px;
        height:28px;
    }
    .divButton:hover{
        background:rgb(240, 82, 116);
        cursor: pointer;
    }
    .item-width  {
        width: 32%;
        height:22px;
    }
    .item-width2  {
        width: 97%;
        height:22px;
    }
    .item-one {
        width: 97%;
        height:22px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
 <style lang ="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th{
            padding:0px;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
 </style>